import { Link } from "react-router-dom";
import axios from "axios";
import React, { useEffect, useState } from "react";
import FormatDateTime from "../../../../shared/utils/dateUtils";
import Cookies from "js-cookie";
import { MdDeleteOutline } from "react-icons/md";
import Swal from "sweetalert2";
import { BiEdit } from "react-icons/bi";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const MyLeadAsset = () => {
  const getToken = () => Cookies.get("jwt");
  const location = useLocation();

  const [LeadAsset, setLeadAsset] = useState([]);
  const [filterTempLeadAsset, setFilterTempLeadAsset] = useState([]);
  const [selectFilterLead, setSelectFilterLead] = useState("pending");
  const [tempDisplayRemoveLeadID, settempDisplayRemoveLeadID] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedType, setSelectedType] = useState("");
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    const key = `scrollPosition_${location.pathname}`;
    const storedScrollPosition = parseInt(localStorage.getItem(key) || "0", 10);
    const handleScroll = () => localStorage.setItem(key, window.scrollY.toString());
    window.addEventListener("scroll", handleScroll);
    setTimeout(() => window.scrollTo(0, storedScrollPosition), 500);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location.pathname]);

  useEffect(() => { fetchData(); }, [selectFilterLead, selectedType]);

  const fetchData = () => {
    axios
      .get(`${process.env.REACT_APP_API}/asset/myleads`, {
        headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "multipart/form-data" },
        params: { status: selectFilterLead, type: selectedType },
      })
      .then((res) => {
        const assets = res.data.assets;
        setLeadAsset(assets);
        setFilterTempLeadAsset(assets.filter((d) => d.status === selectFilterLead));
      })
      .catch(console.log);
  };

  const handleRemoveMyAsset = (leadID) => {
    Swal.fire({
      title: "ยืนยันการลบโพสต์?",
      text: "คุณต้องการลบโพสต์!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "red",
      cancelButtonColor: "#000",
      confirmButtonText: "ยืนยันการลบโพสต์",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(`${process.env.REACT_APP_API}/event/deleteLead`, { lead_id: leadID }, { headers: { Authorization: `Bearer ${getToken()}` } })
          .then(async () => {
            await Swal.fire("สำเร็จ!", "ลบโพสต์สำเร็จ", "success");
            settempDisplayRemoveLeadID(leadID);
            fetchData();
          })
          .catch(console.log);
      }
    });
  };

  const formatedPhoneNumber = (p) =>
    p.length === 10 ? p.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3") : p;

  const handleFilterData = (status) => {
    setSelectFilterLead(status);
    setFilterTempLeadAsset(LeadAsset.filter((d) => d.status === status));
  };

  const filterByDateRange = (assets) => {
    if (startDate && endDate) {
      return assets.filter((a) => {
        const d = new Date(a.date);
        return d >= startDate && d <= endDate;
      });
    }
    return assets;
  };

  const dataFilter = [
    { label: "รออนุมัติ", status: "pending" },
    { label: "สำเร็จ", status: "success" },
    { label: "ไม่สำเร็จ", status: "failed" },
  ];

  const propertyTypes = [
    { label: "ทุกประเภท", value: "" },
    { label: "Townhouse", value: "townhouse" },
    { label: "Land", value: "land" },
    { label: "Condo", value: "condo" },
    { label: "House", value: "house" },
    { label: "Commercial", value: "commercial" },
    { label: "Other", value: "other" },
  ];

  const statusConfig = {
    pending: { label: "รออนุมัติ", cls: "bg-amber-50 text-amber-600 border-amber-100" },
    success: { label: "สำเร็จ", cls: "bg-emerald-50 text-emerald-600 border-emerald-100" },
    failed: { label: "ไม่สำเร็จ", cls: "bg-red-50 text-red-500 border-red-100" },
  };

  const displayData = filterByDateRange(filterTempLeadAsset);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 py-8 space-y-4">

        {/* ── Header ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 px-5 py-4 flex items-center gap-3"
        >
          <Link to="/profiles">
            <div className="w-9 h-9 bg-gray-50 rounded-xl flex items-center justify-center border border-gray-100 hover:bg-gray-100 transition-colors flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
            </div>
          </Link>
          <div className="flex-1">
            <p className="text-xs text-gray-400 uppercase tracking-wider mb-0.5">โปรไฟล์</p>
            <h1 className="text-lg font-bold text-gray-900">Lead ของฉัน</h1>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs px-3 py-1.5 bg-blue-50 text-blue-600 font-semibold rounded-full">
              {filterTempLeadAsset.length === 0 ? LeadAsset.length : filterTempLeadAsset.length} รายการ
            </span>
            <button
              onClick={() => setShowFilters(!showFilters)}
              className="w-8 h-8 bg-gray-50 border border-gray-200 rounded-xl flex items-center justify-center hover:bg-gray-100 transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L13 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 017 21v-7.586L3.293 6.707A1 1 0 013 6V4z" />
              </svg>
            </button>
          </div>
        </motion.div>

        {/* ── Filters (collapsible) ── */}
        <AnimatePresence>
          {showFilters && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.25 }}
              className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden"
            >
              <div className="px-5 py-3.5 border-b border-gray-100">
                <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">ตัวกรอง</p>
              </div>
              <div className="px-5 py-4 space-y-4">
                {/* Date range */}
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">วันที่เริ่มต้น</label>
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      dateFormat="yyyy-MM-dd"
                      isClearable
                      className="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-700 focus:outline-none focus:border-blue-400 focus:bg-white transition-colors"
                      placeholderText="เลือกวันที่"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">วันที่สิ้นสุด</label>
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      dateFormat="yyyy-MM-dd"
                      isClearable
                      className="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-700 focus:outline-none focus:border-blue-400 focus:bg-white transition-colors"
                      placeholderText="เลือกวันที่"
                    />
                  </div>
                </div>

                {/* Property type */}
                <div>
                  <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">ประเภทอสังหาฯ</label>
                  <select
                    value={selectedType}
                    onChange={(e) => setSelectedType(e.target.value)}
                    className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-700 focus:outline-none focus:border-blue-400 focus:bg-white transition-colors"
                  >
                    {propertyTypes.map((t, i) => <option key={i} value={t.value}>{t.label}</option>)}
                  </select>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* ── Status filter tabs ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.05 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 p-2 flex gap-2"
        >
          {dataFilter.map((f, i) => (
            <button
              key={i}
              onClick={() => handleFilterData(f.status)}
              className={`flex-1 py-2 text-sm font-semibold rounded-xl transition-colors ${
                f.status === selectFilterLead
                  ? "bg-blue-600 text-white"
                  : "text-gray-500 hover:bg-gray-50"
              }`}
            >
              {f.label}
            </button>
          ))}
        </motion.div>

        {/* ── Lead cards ── */}
        {displayData.length === 0 ? (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.1 }}
            className="bg-white rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center justify-center py-16 gap-3 text-gray-400"
          >
            <div className="w-14 h-14 bg-gray-100 rounded-2xl flex items-center justify-center">
              <img src="https://cdn-icons-png.flaticon.com/512/10473/10473571.png" alt="" className="w-7 h-7 opacity-30" />
            </div>
            <p className="text-sm">คุณยังไม่มี Lead</p>
          </motion.div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {displayData.map((post, i) => (
              tempDisplayRemoveLeadID !== post.lead_id && (
                <motion.div
                  key={post.lead_id}
                  initial={{ opacity: 0, y: 12 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.35, delay: i * 0.04 }}
                  className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden"
                >
                  {/* Image */}
                  <div className="relative h-44 overflow-hidden">
                    <Link to={`/home?card=full&aid=${post.lead_id}`}>
                      <img src={post.images_url[0]} className="w-full h-full object-cover" alt="" />
                    </Link>
                    <div className="absolute top-2 left-2 flex gap-1.5">
                      <Link to={`/edit/lead/${post.lead_id}`}>
                        <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm">
                          <BiEdit className="w-4 h-4 text-gray-600" />
                        </div>
                      </Link>
                    </div>
                    <button
                      onClick={() => handleRemoveMyAsset(post.lead_id)}
                      className="absolute top-2 right-2 w-8 h-8 bg-red-500 rounded-full flex items-center justify-center shadow-sm hover:bg-red-600 transition-colors"
                    >
                      <MdDeleteOutline className="w-4 h-4 text-white" />
                    </button>
                  </div>

                  {/* Info */}
                  <div className="px-4 py-3">
                    <div className="flex items-center justify-between mb-2">
                      <span className={`text-xs font-semibold px-2.5 py-1 rounded-full border ${statusConfig[post.status]?.cls || "bg-gray-50 text-gray-500 border-gray-100"}`}>
                        {statusConfig[post.status]?.label || post.status}
                      </span>
                      <time className="text-xs text-gray-400">
                        <FormatDateTime isoDateString={post.date} />
                      </time>
                    </div>
                    <p className="text-sm font-semibold text-gray-700">
                      เบอร์โทร: <span className="text-blue-600">{formatedPhoneNumber(post.phone_number)}</span>
                    </p>
                  </div>
                </motion.div>
              )
            ))}
          </div>
        )}

        <div className="h-8" />
      </div>
    </div>
  );
};

export default MyLeadAsset;
